__turbopack_context__.v({
  "wrap": "Group-module-scss-module__79TK0G__wrap",
});
